var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-logo"},[_c('router-link',{attrs:{"to":"/"}},[(_vm.logo)?_c('img',{key:_vm.logo.id,attrs:{"title":_vm.logo.title,"src":_vm.home + _vm.logo.url}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }